import { RichTextEditor as RTE } from '@pearsontechnology/aero-components';

const { Plugins } = RTE;
const { Inserts } = Plugins;

export const RTEConstants = Inserts.constants;